import clsx from 'clsx'
import { IconLayoutGrid, IconList, IconZoom } from '@tabler/icons-react'
import RowContainer from '../../../stories/RowContainer/RowContainer'
import { Typography } from '../../typography'
import { Input } from '../input/StyledTextInput'
import classes from './TeamsPlayersHeader.module.css'

export default function TeamsPlayersHeader({
  title,
  layout,
  setLayout,
  searchValue,
  onSearchChange,
}: {
  title: string
  layout: string
  setLayout(layout: 'grid' | 'list'): void
  searchValue: string
  onSearchChange: (value: string) => void
}) {
  return (
    <RowContainer isTransparent>
      <Typography fs="xl" fw={500} lh="130">
        {title}
      </Typography>
      <div className={classes.header_options}>
        <Input
          placeholder="Search"
          value={searchValue}
          onChange={(event) => onSearchChange(event.currentTarget.value)}
          rightSection={<IconZoom className={classes.select_icon} />}
          rightSectionPointerEvents="none"
          styles={{ root: { maxWidth: '15rem' } }}
        />
        <div className={classes.display_options}>
          <IconList
            className={clsx(classes.layout_icon, {
              [classes.active]: layout === 'list',
            })}
            stroke={1.75}
            onClick={() => setLayout('list')}
          />
          <IconLayoutGrid
            className={clsx(classes.layout_icon, {
              [classes.active]: layout === 'grid',
            })}
            stroke={1.75}
            onClick={() => setLayout('grid')}
          />
        </div>
      </div>
    </RowContainer>
  )
}
